module.exports = __webpack_public_path__ + "img/blue_057.ed39e49a.png";